import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { InteractionStatus } from "@azure/msal-browser";
import { useMsal, useIsAuthenticated } from '@azure/msal-react';
import { Box, Card, CardContent, Button } from '@mui/material';
import { CommonModal } from '../../components';
import { b2cPolicies } from '../../auth/authConfig';
import '../../common/theme/ProfileTheme.scss';
import constants from '../../constants';

const LoginSecurityComponent = (profile) => {
  const contactInfo = profile.contactData;
  const [showModal, setShowModal] = useState(false);
  const ssoAgent = useSelector(state => state.agencyId);
  const { inProgress, instance } = useMsal();
  const isAuthenticated = useIsAuthenticated();
  
  const changePassword = () => {
    if (isAuthenticated && inProgress === InteractionStatus.None) {
      instance.acquireTokenRedirect(b2cPolicies.authorities.changePassword);
    }
  }

  const toggleModal = () => {
    setShowModal(false);
  }

  const changeLoginId = async () => {
    if (isAuthenticated && inProgress === InteractionStatus.None) {
      instance.acquireTokenRedirect(b2cPolicies.authorities.editUserId);
    }
  }

  return (
    <Card className='profile-card'>
      <CardContent className='profile-content'>
        <Box className='profile-title'>Login & security</Box>
        <Box className='profile-text'>This information is only used for AMsuite+. To update your email in Agency Management or declarations pages, please contact Producer Management at licensingandcontracts@amig.com.</Box>

        <Box className='profile-info-box'>
          <Box className='profile-info-content'>
            <Box className='profile-info-header'>Login ID (Email)</Box>
            <Box className='profile-info-value'>{contactInfo.emailAddress}</Box>
            {!ssoAgent ? <Button disableRipple className='reset-button' onClick={() => setShowModal(true)}>Change Login ID (Email)</Button> : null }
          </Box>
 
          <Box>
            <Box className='profile-info-header'>Password</Box>
            <Box className='profile-info-value'>••••••••••••••••</Box>
            <Button disableRipple className='reset-button' onClick={() => changePassword()}>Change password</Button>
          </Box>
        </Box>
        {showModal && (
          <CommonModal type={constants.changeLoginId} toggleModal={toggleModal} action={() => changeLoginId()}/>
        )}  
      </CardContent>
    </Card>
  );
};

export default LoginSecurityComponent;
